import {MapContainer, Marker, TileLayer} from "react-leaflet";
import { AccessibleLabels } from "./AccessibleLabels";

export const OpenStreetMap = ({ lat, lng }) => {
    return (
        <MapContainer center={[lat, lng]} zoom={15} scrollWheelZoom={true} attributionControl={false} zoomControl={true} style={{ width: `100%`, height: `100%` }}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <Marker position={[lat, lng]} />
            <AccessibleLabels />
        </MapContainer>
    )
}